import type { RouteRecordRaw } from 'vue-router'

/**
 * Auth routes — inside the auth shell, so `requiresAuth` is inherited from the
 * parent in router/index.ts and must NOT be re-declared here.
 *
 * No `meta.moduleKey` and no `meta.requiresRole`: access is per-record, not
 * per-role. The backend resolves the owner from the token and 404s a cycle that is
 * not yours, so a role gate here would add nothing and would lock out a SAM whose
 * role string drifts. The paramless route resolves the caller's own open cycle.
 */
export const scholarEngagementRoutes: RouteRecordRaw[] = [
  {
    path: '/scholar-engagement',
    name: 'scholar-engagement',
    component: () => import('@/views/ScholarEngagement/ScholarEngagementForm.vue'),
  },
  {
    path: '/scholar-engagement/:cycleId(\\d+)',
    name: 'scholar-engagement-cycle',
    component: () => import('@/views/ScholarEngagement/ScholarEngagementForm.vue'),
  },
]
